import { useEffect, useState } from 'react'
import { subscribeToAuthTokensRevision } from '@/shared/lib/auth-session-sync'

export function useAuthTokensRevision(): number {
  const [revision, setRevision] = useState(0)

  useEffect(() => {
    return subscribeToAuthTokensRevision(setRevision)
  }, [])

  return revision
}
